import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";

import userSlice from "./UserSlice/userSlice";
import downloadSlice from "./DownloadSlice/downloadSlice";
import imageReducer from "./MainImage/imageSlice";
import previousSettingsSlice from "./PreviousSettings/previousSettingsSlice";
import stickersSlice from "./Stickers/stickersSlice";
import waterMarks from "./WaterMarks/watermarks";
import templateSlice from "./Templates/templateSlice";
import authSlice from "./AuthSlice/authSlice";
import blogSlice from "./BlogsSlice/blogSlice";

const persistConfig = {
  key: "root",
  storage,
  blacklist: [
    "mainImage",
    "stickers",
    "watermarks",
    "templateSlice",
    "previousSettingsSlice",
    "blogSlice",
    "downloadSlice",
  ],
};

const rootReducer = combineReducers({
  mainImage: imageReducer,
  stickers: stickersSlice,
  watermarks: waterMarks,
  downloadSlice: downloadSlice,
  previousSettingsSlice: previousSettingsSlice,
  userSlice: userSlice,
  templateSlice: templateSlice,
  authSlice: authSlice,
  blogSlice: blogSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export type RootState = ReturnType<typeof rootReducer>;

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type AppDispatch = typeof store.dispatch;
export default store;
